const styles = {
  FormItemInput: {
    borderRadius: 6,
    textTransform: "uppercase",
  },
};
export default styles;
